/* eslint-disable react/prop-types */
import classes from "./more-infos.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import TextArea from "@/components-library/widgets/text-area";

function MoreInfos({
  onInterventionsChange,
  onFacilitationChange,
  onInfoChange,
  isInfoValid,
  onCumulationChange,
  isCumulationValid,
  isFacilitationValid,
  isInterventionsValid,
  announcement,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Maggiori Informazioni
      </Label>
      <Grid columns="1fr 1fr 1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isInterventionsValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Interventi ammissibili
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onInterventionsChange}
            defaultValue={announcement?.interventions}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isFacilitationValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Dotazione
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onFacilitationChange}
            defaultValue={announcement?.facilitation}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isInfoValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            INFO UTILI
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onInfoChange}
            defaultValue={announcement?.info}
          />
        </Flex>
      </Grid>
      <Grid columns="1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea, {
            [classes.valid]: isCumulationValid,
          })}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Cumulabilità
          </Label>
          <TextArea
            name="Title"
            rows={4}
            onChange={onCumulationChange}
            defaultValue={announcement?.cumulation}
          />
        </Flex>
      </Grid>
    </Flex>
  );
}

export default MoreInfos;
